import React from "react"
import { Link } from "react-router-dom"

export default function NewsDetailsSection() {
	return (
		<section className="news-standard fix section-padding">
			<div className="container">
				<div className="row g-4">
					<div className="col-12 col-lg-8">
						<div className="blog-post-details">
							<div className="single-blog-post">
								<div
									className="post-featured-thumb"
									style={{
										backgroundImage: 'url("assets/img/news/Blog-1.png")',
										backgroundSize: 'contain',
										backgroundRepeat: 'no-repeat',
										// backgroundPosition: 'center',
										width: '852px',
										height: '460px'
									}}
								/>
								<div className="post-content">
									<ul className="post-list d-flex align-items-center">
										<li>
											<i className="fa-regular fa-user" />
											By Vishal Patel
										</li>
										<li>
											<i className="fa-solid fa-calendar-days" />
											5 May, 2025
										</li>
										{/* <li>
											<i className="fa-solid fa-tag" />
											Technology
										</li> */}
									</ul>
									<h3>Why WPC Doors Are the Future of Indian Homes ?</h3>
									<p className="mb-3">
										With increasing demand for sustainable, low-maintenance solutions, WPC (Wood-Plastic Composite) doors have emerged as the future of interior design across Indian homes. Built to withstand the challenges of climate, usage, and wear, WPC doors offer style without sacrificing performance.
									</p>
									<h5>What Makes WPC Doors Special?</h5>
									<br />
									<ul className=" mb-3 details-list">
										<li>
											<i className="fa-solid fa-circle-check" />
											{" "}100% Waterproof : No swelling, warping, or moisture damage — perfect for kitchens, bathrooms, and balconies.
										</li>
										<li>
											<i className="fa-solid fa-circle-check" />
											{" "}Termite & Pest-Proof : A true alternative to wooden doors, minus the pest worries.
										</li>
										<li>
											<i className="fa-solid fa-circle-check" />
											{" "}No Maintenance Needed : Forget polishing and constant repairs.
										</li>
										<li>
											<i className="fa-solid fa-circle-check" />
											{" "}Eco-Friendly : Made using recycled materials, WPC supports a greener tomorrow.
										</li>
									</ul>
									<p className=" mb-3">
										With V-Make’s WPC doors, you're not just choosing durability — you're investing in smarter, future-ready living. Designed for modern Indian homes, these doors offer the perfect balance of aesthetics and long-term value, without the hassles of traditional materials.
									</p>

									<h5>Applications in Indian Home :</h5>
									<br />
									<ul className=" mb-3 details-list">
										<li>
											<i className="fa-solid fa-circle-check" />
											{" "}Bedroom doors
										</li>
										<li>
											<i className="fa-solid fa-circle-check" />
											{" "}Bathroom doors.
										</li>
										<li>
											<i className="fa-solid fa-circle-check" />
											{" "}Balcony and kitchen entrances
										</li>
										<li>
											<i className="fa-solid fa-circle-check" />
											{" "}Main doors (with lamination or polish)
										</li>
									</ul>
									<p>
										For homeowners seeking functionality, style, and peace of mind, WPC doors are the ultimate upgrade. V-Make offers a wide range of designs and sizes tailored for every space.
									</p>
									{/* <div className="hilight-text mt-4 mb-4">
										<p>
											Pellentesque sollicitudin congue dolor non aliquam. Morbi
											volutpat, nisi vel ultricies urnacondimentum, sapien neque
											lobortis tortor, quis efficitur mi ipsum eu metus.
											Praesent eleifend orci sit amet est vehicula.
										</p>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={36}
											height={36}
											viewBox="0 0 36 36"
											fill="none"
										>
											<path
												d="M7.71428 20.0711H0.5V5.64258H14.9286V20.4531L9.97665 30.3568H3.38041L8.16149 20.7947L8.5233 20.0711H7.71428Z"
												stroke="#F55B1F"
											/>
											<path
												d="M28.2846 20.0711H21.0703V5.64258H35.4989V20.4531L30.547 30.3568H23.9507L28.7318 20.7947L29.0936 20.0711H28.2846Z"
												stroke="#F55B1F"
											/>
										</svg>
									</div> */}
									{/* <p className="mt-4 mb-5">
										Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et
										massa mi. Aliquam in hendrerit urna. Pellentesque sit amet
										sapien fringilla, mattis ligula consectetur, ultrices
										mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet
										augue. Vestibulum auctor ornare leo, non suscipit magna
										interdum eu. Curabitur pellentesque nibh nibh, at maximus
										ante fermentum sit amet. Pellentesque commodo lacus at
										sodales sodales. Quisque sagittis orci ut diam condimentum,
										vel euismod erat placerat. In iaculis arcu eros.
									</p> */}
									{/* <div className="row g-4">
										<div className="col-lg-6">
											<div className="details-image">
												<img src="assets/img/news/post-5.jpg" alt="img" />
											</div>
										</div>
										<div className="col-lg-6">
											<div className="details-image">
												<img src="assets/img/news/post-6.jpg" alt="img" />
											</div>
										</div>
									</div> */}
									{/* <p className="pt-5">
										Consectetur adipisicing elit, sed do eiusmod tempor
										incididunt ut labore et dolore of magna aliqua. Ut enim ad
										minim veniam, made of owl the quis nostrud exercitation
										ullamco laboris nisi ut aliquip ex ea dolor commodo
										consequat. Duis aute irure and dolor in
										reprehenderit.Consectetur adipisicing elit, sed do eiusmod
										tempor incididunt ut labore et dolore of magna aliqua. Ut
										enim ad minim veniam, made of owl the quis nostrud
										exercitation ullamco laboris nisi ut aliquip ex ea dolor
										commodo consequat. Duis aute irure and dolor in
										reprehenderit.
									</p> */}
								</div>
							</div>
							{/* <div className="row tag-share-wrap mt-4 mb-5">
								<div className="col-lg-8 col-12">
									<div className="tagcloud">
										<span>Tags:</span>
										<Link to="/news-details">Travel</Link>
										<Link to="/news-details">Services</Link>
										<Link to="/news-details">Agency</Link>
									</div>
								</div>
								<div className="col-lg-4 col-12 mt-3 mt-lg-0 text-lg-end">
									<div className="social-share">
										<span className="me-3">Share:</span>
										<Link to="/#">
											<i className="fab fa-facebook-f" />
										</Link>
										<Link to="/#">
											<i className="fab fa-twitter" />
										</Link>
										<Link to="/#">
											<i className="fab fa-linkedin-in" />
										</Link>
										<Link to="/#">
											<i className="fab fa-youtube" />
										</Link>
									</div>
								</div>
							</div> */}
							{/* <div className="comments-area">
								<div className="comments-heading">
									<h3>02 Comments</h3>
								</div>
								<div className="blog-single-comment d-flex gap-4 pt-4 pb-5">
									<div className="image">
										<img src="assets/img/news/comment-1.png" alt="image" />
									</div>
									<div className="content">
										<div className="head d-flex flex-wrap gap-2 align-items-center justify-content-between">
											<div className="con">
												<h5>
													<Link to="/news-details">Albert Flores</Link>
												</h5>
												<span>February 10, 2024 at 2:37 pm</span>
											</div>
											<div className="star">
												<i className="fa-solid fa-star" />
												<i className="fa-solid fa-star" />
												<i className="fa-solid fa-star" />
												<i className="fa-solid fa-star" />
												<i className="fa-solid fa-star" />
											</div>
										</div>
										<p className="mt-30 mb-4">
											Neque porro est qui dolorem ipsum quia quaed inventor
											veritatis et quasi architecto var sed efficitur turpis
											gilla sed sit amet finibus eros. Lorem Ipsum is simply
											dummy
										</p>
										<Link to="/news-details" className="reply">
											Reply
										</Link>
									</div>
								</div> */}
							{/* <div className="blog-single-comment d-flex gap-4 pt-5 pb-5">
									<div className="image">
										<img src="assets/img/news/comment-2.png" alt="image" />
									</div>
									<div className="content">
										<div className="head d-flex flex-wrap gap-2 align-items-center justify-content-between">
											<div className="con">
												<h5>
													<Link to="/news-details">Alex Flores</Link>
												</h5>
												<span>February 10, 2024 at 2:37 pm</span>
											</div>
											<div className="star">
												<i className="fa-solid fa-star" />
												<i className="fa-solid fa-star" />
												<i className="fa-solid fa-star" />
												<i className="fa-solid fa-star" />
												<i className="fa-solid fa-star" />
											</div>
										</div>
										<p className="mt-30 mb-4">
											Neque porro est qui dolorem ipsum quia quaed inventor
											veritatis et quasi architecto var sed efficitur turpis
											gilla sed sit amet finibus eros. Lorem Ipsum is simply
											dummy
										</p>
										<Link to="/news-details" className="reply color-2">
											Reply
										</Link>
									</div>
								</div>
							</div> */}
							{/* <div className="comment-form-wrap pt-5">
								<h3>Leave a comments</h3>
								<form action="#" id="contact-form" method="POST">
									<div className="row g-4">
										<div className="col-lg-6">
											<div className="form-clt">
												<span>Your Name*</span>
												<input
													type="text"
													name="name"
													id="name"
													placeholder="Your Name"
												/>
											</div>
										</div>
										<div className="col-lg-6">
											<div className="form-clt">
												<span>Your Email*</span>
												<input
													type="text"
													name="email"
													id="email2"
													placeholder="Your Email"
												/>
											</div>
										</div>
										<div className="col-lg-12">
											<div className="form-clt">
												<span>Message*</span>
												<textarea
													name="message"
													id="message"
													placeholder="Write Message"
													defaultValue={""}
												/>
											</div>
										</div>
										<div className="col-lg-6">
											<button type="submit" className="theme-btn ">
												post comment
												<i className="fa-solid fa-arrow-right-long" />
											</button>
										</div>
									</div>
								</form>
							</div> */}
						</div>
					</div>
					<div className="col-12 col-lg-4">
						<div className="main-sidebar">
							{/* <div className="single-sidebar-widget">
								<div className="wid-title">
									<h3>Search</h3>
								</div>
								<div className="search-widget">
									<form action="#">
										<input type="text" placeholder="Search here" />
										<button type="submit">
											<i className="fa-solid fa-magnifying-glass" />
										</button>
									</form>
								</div>
							</div> */}
							{/* <div className="single-sidebar-widget">
								<div className="wid-title">
									<h3>Categories</h3>
								</div>
								<div className="news-widget-categories">
									<ul>
										<li>
											<Link to="/news-details">Cargo Insurance </Link>{" "}
											<span>5</span>
										</li>
										<li>
											<Link to="/news-details">Logistic Strategy</Link>{" "}
											<span>3</span>
										</li>
										<li className="active">
											<Link to="/news-details">Our Delivery </Link>
											<span>4</span>
										</li>
										<li>
											<Link to="/news-details">Shipment Solutions </Link>{" "}
											<span>2</span>
										</li>
										<li>
											<Link to="/news-details">Security System</Link>{" "}
											<span>3</span>
										</li>
									</ul>
								</div>
							</div> */}
							<div className="single-sidebar-widget">
								<div className="wid-title">
									<h3>Recent Post</h3>
								</div>
								<div className="recent-post-area">
									<div className="recent-items">
										<div className="recent-thumb">
										<img src="assets/img/news/Blog-2.png" alt="img" style={{ width: '70px', height: '70px', objectFit: 'cover' }} />
										</div>
										<div className="recent-content">
											<ul>
												<li>
													<i className="fa-solid fa-calendar-days" />
													10 May 2025
												</li>
											</ul>
											<h6>
												<Link to="/blog-details-2">
													WPC vs. Wooden Doors – What Should You Choose?
												</Link>
											</h6>
										</div>
									</div>
									<div className="recent-items">
										<div className="recent-thumb">
										<img src="assets/img/news/Blog-3.jpg" alt="img" style={{ width: '70px', height: '70px', objectFit: 'cover' }} />
										</div>
										<div className="recent-content">
											<ul>
												<li>
													<i className="fa-solid fa-calendar-days" />
													15 May 2025
												</li>
											</ul>
											<h6>
												<Link to="/blog-details-3">
													How to Choose the Right WPC Door Frame for Your Project ?
												</Link>
											</h6>
										</div>
									</div>
									{/* <div className="recent-items">
										<div className="recent-thumb">
											<img src="assets/img/news/pp4.jpg" alt="img" />
										</div>
										<div className="recent-content">
											<ul>
												<li>
													<i className="fa-solid fa-calendar-days" />
													09 July 2024
												</li>
											</ul>
											<h6>
												<Link to="/news-details">
													How to Recruit and Retain Drivers
												</Link>
											</h6>
										</div>
									</div> */}
								</div>
							</div>
							{/* <div className="single-sidebar-widget">
								<div className="wid-title">
									<h3>Popular Tag</h3>
								</div>
								<div className="news-widget-categories">
									<div className="tagcloud">
										<Link to="/news-details">transport</Link>
										<Link to="/news-details">cargo</Link>
										<Link to="/news-details">engineering</Link>
										<Link to="/news-details">Design</Link>
										<Link to="/news-details">engineering</Link>
										<Link to="/news-details">delivery</Link>
									</div>
								</div>
							</div> */}
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
